import styled from 'styled-components'

const CloseButton = styled.button`
  background-color: #333;
  border: 3px solid #fff;
  border-radius: 2em;
  height: 40px;
  width: 40px;

  &::before,
  &::after {
    background-color: #fff;
    content: '';
    display: block;
    height: 18px;
    position: absolute;
    right: 15px;
    top: 8px;
    width: 3px;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`

export default CloseButton
